import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { addDestination } from "../../apis/firebase";
import { DestinationType, YOUTUBE_CLIENT_ID } from "../../constants";
import { addUserDestination } from "../../state/User";
import { getParameter, verifyRealUser } from "../helpers";
import { closePopUp, showAlertPopUp, showLoadingPopUp } from "../utils/Overlay";

export function AddYouTubeDestination({
  onError,
  user,
}: {
  onError: Function;
  user: User;
}) {
  const [inProgress, setProgressFlag] = useState(false);
  const redirect = encodeURIComponent(
    window.location.href.split("?")[0] + "?integration=youtube"
  );
  const params = {
    scope:
      encodeURIComponent("https://www.googleapis.com/auth/youtube.upload") +
      // " " +
      // encodeURIComponent("https://www.googleapis.com/auth/youtubepartner") +
      // " " +
      // encodeURIComponent("https://www.googleapis.com/auth/youtube.force-ssl") +
      " " +
      encodeURIComponent("https://www.googleapis.com/auth/youtube.readonly"),
    include_granted_scopes: "true",
    state: "state_parameter_passthrough_value",
    redirect_uri: redirect,
    response_type: "code",
    client_id: YOUTUBE_CLIENT_ID,
    access_type: "offline",
  };
  const url = inProgress
    ? "#"
    : `https://accounts.google.com/o/oauth2/v2/auth?${Object.keys(params)
        .map((key) => `${key}=${params[key]}`)
        .join("&")}`;

  useEffect(() => {
    const code = getParameter("code");
    const integration = getParameter("integration");
    const error = getParameter("error");
    if (code && integration === "youtube") {
      setProgressFlag(true);
      async function getRefreshToken() {
        showLoadingPopUp("Linking your YouTube account. Please wait.");
        const res = await fetch(
          `/api/yt?code=${code}&redirect_url=${redirect}`
        );
        if (res.status === 200) {
          const { refresh_token, channels } = await res.json();
          if (channels.length === 0) {
            showAlertPopUp(
              "You have no YouTube channels created by this account."
            );
            setProgressFlag(false);
          } else {
            await Promise.all(
              channels.map(async (channel) => {
                const name = get(channel, "snippet.title", "YouTube");
                const newDestination = await addDestination(
                  user,
                  DestinationType.YOUTUBE,
                  {
                    refreshToken: refresh_token,
                    channel: {
                      id: channel.id,
                      name,
                    },
                  },
                  {
                    id: channel.id,
                    name,
                  }
                );
                addUserDestination(newDestination);
              })
            );
            setProgressFlag(false);
            closePopUp();
          }
        } else {
          onError(["Error linking to YouTube.", "/help/youtube"]);
        }
        setProgressFlag(false);
        closePopUp();
      }
      getRefreshToken();
    } else if (error) {
      console.error(error);
      onError("Error linking to YouTube.");
      setProgressFlag(false);
    }
  }, []);

  if (user.demo) {
    return (
      <button
        onClick={() => verifyRealUser(user, () => {})}
        className="secondary with-icon fz08"
      >
        <span className="vam">Link a YouTube account</span>
      </button>
    );
  }

  return (
    <a
      href={url}
      className="secondary with-icon fz08"
      data-disabled={inProgress}
    >
      {inProgress ? "⏳ " : null}
      <span className="vam">Link a YouTube account</span>
    </a>
  );
}
